import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { RegexEnum } from "../../../../../views/regex.enum";
import { InternalTestService } from "../../services/internaltest.service";

@Component({
  templateUrl: "./internaltest.component.html"
})
export class InternalTestComponent implements OnInit {
  public tests: any;
  public successMsg: string = "";
  public display = "none";
  public popUpType: string;
  public displayOrderErr: string = "";
  public testNmErr: string = "";
  public testForeignCdErr: string = "";
  public testForeignSysCdErr: string = "";
  public statusErr: string = "";
  public displayOrderNumber: number;
  public test: any = {};
  public statusCode: any = [];

  constructor(private internalTestService: InternalTestService) {}

  ngOnInit() {
    this.statusCode = [
      { id: "A", code: "Active" },
      { id: "I", code: "Inactive" },
      { id: "", code: "Please Select" }
    ];
    Observable.forkJoin(this.internalTestService.getAllTests()).subscribe(
      ([resp]) => {
        this.tests = resp;
      }
    );
  }

  openTestPopUp(item: any, type: string) {
    this.test.TEST_ID = "";
    this.popUpType = type;
    if (this.popUpType === "Edit") {
      this.test.STATUS_CD = item.STATUS_CD;
      this.test.TEST_NM = item.TEST_NM;
      this.test.TEST_ID = item.TEST_ID;
      this.test.DISPLAY_ORDER_NO = item.DISPLAY_ORDER_NO;
      this.test.TEST_FOREIGN_CD = item.TEST_FOREIGN_CD;
      this.test.TEST_FOREIGN_SYSTEM_CD = item.TEST_FOREIGN_SYSTEM_CD;
      this.displayOrderNumber = item.DISPLAY_ORDER_NO;
      if (this.test.STATUS_CD === "Inactive") {
        this.test.STATUS_CD = "I";
      } else if (this.test.STATUS_CD === "Active") {
        this.test.STATUS_CD = "A";
      }
    } else {
      this.test.TEST_NM = "";
      this.test.TEST_FOREIGN_CD = "";
      this.test.TEST_FOREIGN_SYSTEM_CD = "";
      this.test.DISPLAY_ORDER_NO = null;
      this.test.STATUS_CD = "";
    }

    this.display = "block";
  }

  save() {
    if (this.popUpType === "Add") {
      this.addRow();
    } else if (this.popUpType === "Edit") {
      this.editRow();
    }
  }

  addRow() {
    let addRow: boolean = false;
    addRow = this.validateAddForm();
    if (addRow) {
      this.internalTestService.addTest(this.test).subscribe(
        resp => {
          if (resp) {
            this.successMsg = "Test has been added successfully.";
            this.closeTestPopUp();
            this.ngOnInit();
          }
        },
        err => {
          if (err.error.error.message.includes("TEST_NM")) {
            this.testNmErr = "Test Code is not valid";
          } else if (err.error.error.message.includes("TEST_FOREIGN_CD")) {
            this.testForeignCdErr = "Test Foreign Code is not valid";
          } else if (
            err.error.error.message.includes("TEST_FOREIGN_SYSTEM_CD")
          ) {
            this.testForeignSysCdErr = "Test Foreign System Code not valid";
          } else if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
            this.displayOrderErr = "Display Order Number is not Valid";
          } else {
            this.testNmErr = "Test code must be unique";
          }
        }
      );
    }
  }

  editRow() {
    let editRow: boolean = false;
    editRow = this.validateEditForm();
    if (editRow) {
      this.internalTestService.editTest(this.test).subscribe(
        response => {
          if (response) {
            this.successMsg = "All your changes have been saved.";
            this.closeTestPopUp();
            this.ngOnInit();
          }
        },
        err => {
          if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
            this.displayOrderErr = "Display Order Number is not Valid";
          }
        }
      );
    }
  }

  validateAddForm() {
    const emptyOrOnlyWhiteSpace = new RegExp(RegexEnum.EMPTY_OR_WHITESPACE);

    if (emptyOrOnlyWhiteSpace.test(this.test.TEST_NM)) {
      const testNamePattern = RegexEnum.TEST_NAME_PATTERN;
      const regex = new RegExp(testNamePattern);
      if (regex.test(this.test.TEST_NM)) {
        const duplicateTestName = this.tests.some(
          item => item.TEST_NM === this.test.TEST_NM
        );
        if (duplicateTestName) {
          this.testNmErr = "Test Name must be unique";
        } else {
          this.testNmErr = "";
        }
      } else {
        this.testNmErr = "Test Name is not valid";
      }
    } else {
      this.testNmErr = "Test Name is required";
    }

    if (emptyOrOnlyWhiteSpace.test(this.test.TEST_FOREIGN_CD)) {
      const testForeignCodePattern = RegexEnum.TEST_FOREIGN_CODE_PATTERN;
      const regex = new RegExp(testForeignCodePattern);
      if (regex.test(this.test.TEST_FOREIGN_CD)) {
        this.testForeignCdErr = "";
      } else {
        this.testForeignCdErr = "Test Foreign Code is not valid";
      }
    } else {
      this.testForeignCdErr = "Test Foreign Code is required";
    }

    if (emptyOrOnlyWhiteSpace.test(this.test.TEST_FOREIGN_SYSTEM_CD)) {
      const testForeignSystemCodePattern =
        RegexEnum.TEST_FOREIGN_SYSTEM_CODE_PATTERN;
      const regex = new RegExp(testForeignSystemCodePattern);
      if (regex.test(this.test.TEST_FOREIGN_SYSTEM_CD)) {
        this.testForeignSysCdErr = "";
      } else {
        this.testForeignSysCdErr = "Test Foreign System Code is not valid";
      }
    } else {
      this.testForeignSysCdErr = "Test Foreign System Code is required";
    }

    if (this.test.DISPLAY_ORDER_NO && this.tests.length > 0) {
      this.test.DISPLAY_ORDER_NO = Number(this.test.DISPLAY_ORDER_NO);
      const duplicateNumber = this.tests.some(
        item => item.DISPLAY_ORDER_NO === this.test.DISPLAY_ORDER_NO
      );
      if (duplicateNumber) {
        this.displayOrderErr = "Display Order must be unique";
      } else {
        this.displayOrderErr = "";
      }
    } else {
      this.displayOrderErr = "Display Order No is required";
    }

    if (this.test.STATUS_CD) {
      this.statusErr = "";
    } else {
      this.statusErr = "Please Select a status";
    }

    if (
      this.testNmErr ||
      this.testForeignCdErr ||
      this.testForeignSysCdErr ||
      this.displayOrderErr ||
      this.statusErr
    ) {
      return false;
    } else {
      return true;
    }
  }

  validateEditForm() {
    if (!this.test.DISPLAY_ORDER_NO) {
      this.displayOrderErr = "Display Order No is required";
    } else {
      if (this.test.DISPLAY_ORDER_NO && this.tests.length > 0) {
        this.test.DISPLAY_ORDER_NO = Number(this.test.DISPLAY_ORDER_NO);
        if (this.displayOrderNumber !== this.test.DISPLAY_ORDER_NO) {
          const duplicateNumber = this.tests.some(
            item => item.DISPLAY_ORDER_NO === this.test.DISPLAY_ORDER_NO
          );
          if (duplicateNumber) {
            this.displayOrderErr = "Display Order must be unique within Test";
          } else {
            this.displayOrderErr = "";
          }
        } else {
          this.displayOrderErr = "";
        }
      } else {
        this.displayOrderErr = "";
      }
    }

    if (this.test.STATUS_CD) {
      this.statusErr = "";
    } else {
      this.statusErr = "Please Select a status";
    }
    if (this.statusErr || this.displayOrderErr) {
      return false;
    } else {
      return true;
    }
  }

  closeTestPopUp() {
    this.resetForm();
    this.display = "none";
  }

  resetForm() {
    this.testNmErr = "";
    this.testForeignCdErr = "";
    this.testForeignSysCdErr = "";
    this.displayOrderErr = "";
    this.statusErr = "";
    this.successMsg = "";
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/internal-test/internaltest.component.ts